export function prepareSafariOwnCarAssignments(assignments) {
  return assignments.map(item => ({
    ...item,
    _initial_car_assignment_locked: Boolean(item.car_assignment_locked),
    _initial_guide_assignment_locked: Boolean(item.guide_assignment_locked),
  }))
}

export async function changeSafariAssignmentLock(unlock, safariId, assignment, field, value) {
  const initialField = `_initial_${field}`
  if (!value && assignment[initialField]) {
    await unlock(safariId, {
      assignment_id: assignment.id,
      field: field === 'car_assignment_locked' ? 'car' : 'guide',
    })
    assignment[initialField] = false
  }
  assignment[field] = value
}
